import React, { useState, useContext } from "react";
import { AppContext } from '../../application/provider';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Table, Toast, ToastBody, ToastHeader, Form, FormGroup } from 'reactstrap';
import "./ModalEditEstadoProspecto.css";
import ProspectoService from "../../axios_services/prospectos.service";
import { Switch } from '@tremor/react';
import Loader from '../../components/Loader/Loader';

function ModalEditEstadoProspecto({ isOpen }) {

    const [state, setState] = useContext(AppContext);
    const [usuario, setUsuario] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isSaved, setIsSaved] = useState(false);

    //CATALOGOS
    const [gestores] = useState(state.user.personal.filter(p => { return p.perfil_id == 3 || (p.perfil_id == 4 || p.perfil_id == 27) }));
    const [estado] = useState(state.catalogos.tipos.filter(t => t.categoria_id == 9));
    const [detalle_credito_fallido] = useState(state.catalogos.tipos.filter(t => t.categoria_id == 47));

    const actualizarProspecto = () => {
        setState((prevState) => ({
            ...prevState,
            isUpdated: true
        }));
    };

    const updateEvaluacionProspecto = async () => {
        try {
            const data = await ProspectoService.updateEvaluacionProspecto(
                state.prospecto_id,
                state.zonal_prospecto,
                state.gestor_prospecto,
                state.user?.usuario_id
            );
            alert("Prospecto liberado satisfactoriamente");
            await cerrarModal();
        } catch (error) {
            if (error.response && error.response.data && error.response.data.error) {
                alert(`Error: ${error.response.data.error}`);
            } else {
                alert("Hubo un error al liberar al prospecto. Intenta nuevamente.");
            }
        }
    };

    const liberarDesembolsadoProspecto = async () => {
        try {
            const data = await ProspectoService.liberarDesembolsadoProspecto(
                state.prospecto_id,
                state.user?.usuario_id
            );
            alert("Prospecto liberado satisfactoriamente");
            await cerrarModal();
        } catch (error) {
            if (error.response && error.response.data && error.response.data.error) {
                alert(`Error: ${error.response.data.error}`);
            } else {
                alert("Hubo un error al liberar al prospecto. Intenta nuevamente.");
            }
        }
    };

    const guardarGestion = async () => {
        setLoading(true);
        try {
            await ProspectoService.gestionarProspecto(
                state.prospecto_id,
                state.contactado_id, // ensure this is passed to state
                state.estado_prospecto,
                state.user?.usuario_id,
                state.credito_fallido_id
            );
            alert("Gestión guardada satisfactoriamente");
            actualizarProspecto();
            await cerrarModal();
        } catch (error) {
            alert("Hubo un error al guardar la gestión.");
        } finally {
            setLoading(false);
        }
    };

    function cerrarModal() {
        setState((prevState) => ({
            ...prevState,
            modalEditEstadoProspecto: false,
            isUpdated: false,
            prospecto_id: null,
            estado_prospecto: null,
            gestor_prospecto: null
        }));
    };

    return (
        state.modalEditEstadoProspecto === true && (<Modal isOpen={state.modalEditEstadoProspecto} className="custom-modal" backdrop={true}>
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>{state.prospecto_nombre}</h1>
                    <Button className="close-btn" onClick={cerrarModal}>X</Button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                {loading ? (
                    <Loader />
                ) : (
                    <ModalBody className="modal-body">
                        <Form className="fila">
                            <FormGroup>
                                <label className="label">Estado:</label>
                                <select
                                    className="form-control"
                                    value={state.estado_prospecto || ''}
                                    onChange={(e) => setState({ ...state, estado_prospecto: e.target.value ? Number(e.target.value) : null })}
                                >
                                    <option value="">Seleccione...</option>
                                    <optgroup label="Proceso">
                                        {estado.filter(item => [1, 3, 12].includes(Number(item.tipo_id))).map((item) => (
                                            <option key={item.tipo_id} value={item.tipo_id}>{item.descripcion}</option>
                                        ))}
                                    </optgroup>
                                    <optgroup label="Motivo">
                                        {estado.filter(item => [2, 4, 5, 10, 9].includes(Number(item.tipo_id))).map((item) => (
                                            <option key={item.tipo_id} value={item.tipo_id}>{item.descripcion}</option>
                                        ))}
                                    </optgroup>
                                </select>
                            </FormGroup>
                            <div className="mb-3">
                                <label className="label">Detalle:</label>
                                <select
                                    className="form-control"
                                    value={state.credito_fallido_id || 0}
                                    onChange={(e) => setState({ ...state, credito_fallido_id: e.target.value })}
                                >
                                    <option value="0">Seleccione...</option>
                                    <optgroup label="Cmac">
                                        {detalle_credito_fallido.filter(item => Number(item.tipo_id) >= 1 && Number(item.tipo_id) <= 4).map((item) => (
                                            <option key={item.tipo_id} value={item.tipo_id}>
                                                {item.descripcion}
                                            </option>
                                        ))}
                                    </optgroup>
                                    <optgroup label="Prospecto">
                                        {detalle_credito_fallido.filter(item => Number(item.tipo_id) >= 5 && Number(item.tipo_id) <= 6).map((item) => (
                                            <option key={item.tipo_id} value={item.tipo_id}>
                                                {item.descripcion}
                                            </option>
                                        ))}
                                    </optgroup>
                                    <optgroup label="Mec">
                                        {detalle_credito_fallido.filter(item => Number(item.tipo_id) === 7).map((item) => (
                                            <option key={item.tipo_id} value={item.tipo_id}>
                                                {item.descripcion}
                                            </option>
                                        ))}
                                    </optgroup>
                                </select>
                            </div>
                            {Number(state.estado_prospecto) === 3 && (<FormGroup>
                                <label className="label">Gestor:</label>
                                <select
                                    className="form-control"
                                    name="gestor_id"
                                    value={state.gestor_prospecto}
                                    disabled={Number(state.estado_prospecto) === 3}
                                    onChange={(e) => setState({ ...state, gestor_prospecto: e.target.value })}
                                >
                                    {gestores
                                        .filter(item => (item.usuario_id_jefe_inmediato === state.zonal_prospecto) || (item.usuario_id_jefe_jefe_inmediato === state.zonal_prospecto))
                                        .map((item) => (
                                            <option key={item.usuario_id} value={item.usuario_id}>
                                                {item.nombre_completo_usuario}
                                            </option>
                                        ))}
                                </select>
                            </FormGroup>)}
                        </Form>
                        <div className="button-container fila">
                            <Button
                                className="button-custom"
                                disabled={(Number(state.estado_prospecto) === 3 || Number(state.estado_prospecto) === 11)}
                                onClick={async () => {
                                    const userConfirmed = window.confirm(`Esta acción liberará de su estado evaluacion a este prospecto.` +
                                        "¿Está seguro de que desea proceder?");
                                    if (userConfirmed) {
                                        if (Number(state.estado_prospecto) === 3) {
                                            await updateEvaluacionProspecto();
                                        } else if (Number(state.estado_prospecto) === 11) {
                                            await liberarDesembolsadoProspecto();
                                        }
                                        actualizarProspecto();
                                    }
                                }}
                            >
                                Liberar
                            </Button>
                            <Button
                                className="button-custom ms-2"
                                style={{ backgroundColor: '#4CAF50', border: 'none' }}
                                onClick={guardarGestion}
                            >
                                Guardar
                            </Button>
                        </div>
                    </ModalBody>)}
            </div>
        </Modal>)

    );
}

export default ModalEditEstadoProspecto;